import { useEffect, useState } from "react";
import Lottie from "react-lottie";
import styled from "styled-components";
import noLogoImage from "../../assets/images/common/no-image-placeholder.png";
import noProfileImage from "../../assets/images/common/no-image-profile.jpg";
import * as Library from "../../utils/Library";
import animationData from "./../../assets/animations/loader-animation.json";
import DialogBoxComponent from "./dialogs/DialogBoxComponent";
import FullScreenOverlay from "./overlay/FullScreenOverlay";

const StyledLayout = styled.div`
    .topContent {
        display: flex;
        gap: 16px;
        height: 206px;
        width: 100%;
        padding: 16px 0;
        align-self: stretch;
    }
    .profileImage {
        border-radius: 4px;
        min-width: 174px;
        max-width: 174px;
        height: 100%;
        max-height: 174px;
        background-color: #141922;
        align-items: center;
        display: flex;
        justify-content: center;
    }
    .profileImage img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 4px;
    }
    .brandLogo {
        border-radius: 4px;
        width: 100%;
        height: 100%;
        background-color: #141922;
        align-items: center;
        display: flex;
        justify-content: center;
    }
    .brandLogo img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        border-radius: 4px;
        padding: 24px 32px;
    }
    .mainInfo {
        align-items: start;
        display: flex;
        flex-direction: column;
        gap: 6px;
        font-family: Roboto;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        padding-bottom: 16px;
    }
    .mainInfoLabel {
        display: flex;
        gap: 4px;
        align-items: center;
    }
    .value {
        color: var(--text-icons-blue-500, #00aeef);

        /* Subtitle 2 */
        font-family: Roboto;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 200px;
    }
    .info {
        display: flex;
        flex-direction: column;
        gap: 16px;
        width: 100%;
        font-size: 10px;
    }
    .infoTitle {
        display: flex;
        align-items: center;
        gap: 10px;
        width: 100%;
    }
    .infoLabel {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .dividerHorizontal {
        width: 100%;
        height: 1px;
        background-color: #3c485a;
        margin: 8px 0;
        flex: 1;
    }
    .dividerVertical {
        width: 1px;
        height: 100%;
        background-color: #3c485a;
        margin: 0 8px;
    }
    .storesList {
        display: flex;
        flex-direction: column;
        gap: 16px;
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        max-height: 320px;
        overflow-y: scroll;
    }

    .storeImage {
        position: relative;
        border-radius: 4px;
        width: 100%;
        height: 150px;
        background-color: #141922;
        align-items: center;
        display: flex;
        justify-content: center;
    }
    .storeImage::after {
        content: "";
        position: absolute;
        inset: 0;
        background: linear-gradient(0deg, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0.6) 100%);
        z-index: 0;
    }
    .storeImage img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 4px;
    }
    .storeCard {
        display: flex;
        flex-direction: column;
        width: 100%;
        font-size: 10px;
    }
    .infoStore {
        display: flex;
        flex-direction: column;
        position: absolute;
        z-index: 1;
        color: #fff;
        text-align: center;

        /* Subtitle 1 */
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        letter-spacing: 0.035px;
        max-width: 170px;
        gap: 4px;
    }
    .bottomContent {
        display: flex;
        width: 100%;
        gap: 8px;
        margin-top: 16px;
    }

    .CardBox-button-a {
        width: 143px;
        height: 35px;
        background: var(--backgrounds-lines-n-600, #10141b);
        border: none;
        /*color: var(--Buttons-All-Platforms-Gray-100);*/
        color: #ffffff;
        border-radius: 4px;
        outline: none;
    }

    .CardBoxDisabled {
        background-color: #10141b;
        color: #4f5b6d;
        cursor: not-allowed;
    }
`;

export default function PopupWhoIsThis({
    isOpen = false,
    setIsOpen,
    inviteID,
    data,
    onDeclineInvitation,
    onAcceptInvitation
}) {
    return (
        <FullScreenOverlay show={isOpen}>
            <DialogBoxComponent
                heading="WHO IS THIS?"
                showCancel={false}
                showConfirm={false}
                width="900px"
                useAlternativeLayout={
                    <PopupLayout
                        setIsOpen={setIsOpen}
                        inviteID={inviteID}
                        onDeclineInvitation={onDeclineInvitation}
                        onAcceptInvitation={onAcceptInvitation}
                        item={data}
                    />
                }
            />
        </FullScreenOverlay>
    );
}

function PopupLayout({ setIsOpen, inviteID, onDeclineInvitation, onAcceptInvitation, item }) {
    const [whoIsThisData, setWhoIsThisData] = useState(null);
    const [isLoading, setIsLoadingLocal] = useState(false);
    const accountOwnerName = localStorage.getItem("userFirstName");

    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };

    const status = item?.status;

    const canAcceptInvite = status === "Request" || status === "Invited" || status === "Enrolled";

    const formatAddress = address => {
        if (!address) return "--";

        const parts = [];

        if (address.addressLine1) parts.push(address.addressLine1);
        if (address.addressLine2) parts.push(address.addressLine2);

        const locationParts = [];
        if (address.postalCode) locationParts.push(address.postalCode);
        if (address.city) locationParts.push(address.city);

        if (locationParts.length > 0) parts.push(locationParts.join(" "));
        if (address.countryValue) parts.push(address.countryValue);

        return parts.join(", ") || "--";
    };

    useEffect(() => {
        if (!inviteID) return;

        setIsLoadingLocal(true);

        Library.makeApiRequest({
            endpoint: "getInviteWhoIsThis",
            data: { inviteID: inviteID }
        })
            .then(res => {
                setWhoIsThisData(res.data.data);
                setIsLoadingLocal(false);
            })
            .catch(error => {
                console.error("Error fetching Who Is This data:", error);
                setIsLoadingLocal(false);
            });
    }, [inviteID]);

    if (isLoading) {
        return (
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "400px" }}>
                <Lottie options={defaultOptions} height={120} width={120} />
            </div>
        );
    }

    return (
        <StyledLayout>
            <div className="topContent">
                <div className="profileImage">
                    <img alt="Profile" src={whoIsThisData?.invitedByUserInfo?.profilePhotoUrl || noProfileImage} />
                </div>
                <div className="brandLogo">
                    <img alt="Brand" src={whoIsThisData?.labelBrnadInfo?.logo || noLogoImage} />
                </div>
            </div>
            <div className="mainInfo">
                <div className="mainInfoLabel">
                    Label Brand: <div className="value">{whoIsThisData?.labelBrnadInfo.name}</div>
                </div>
                <div className="mainInfoLabel">
                    BOtag account owner: <div className="value">{accountOwnerName || "--"}</div>
                </div>
            </div>

            <div style={{ display: "flex", gap: "8px", width: "100%" }}>
                <div style={{ display: "flex", gap: "8px", width: "100%" }}>
                    <div className="info">
                        <div className="infoTitle">
                            <div style={{ fontSize: "8px", width: "auto", whiteSpace: "nowrap" }}>COMPANY INFO</div>
                            <div className="dividerHorizontal" />
                        </div>
                        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                            <div className="infoLabel">
                                <div>Company:</div>
                                <div className="value">{whoIsThisData?.companyInfo?.name || "--"}</div>
                            </div>
                            <div className="infoLabel">
                                <div>Registartion number:</div>
                                <div className="value">{whoIsThisData?.companyInfo?.registrationNumber || "--"}</div>
                            </div>
                            <div className="infoLabel">
                                <div>Country:</div>
                                <div className="value">{whoIsThisData?.companyInfo?.countryName || "--"}</div>
                            </div>
                            <div className="infoLabel">
                                <div>Address:</div>
                                <div className="value" style={{ maxWidth: "200px" }}>
                                    {formatAddress(whoIsThisData?.companyInfo?.address)}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="dividerVertical" />
                </div>
                {/* <div style={{ display: "flex", gap: "8px", width: "100%" }}>
                    <div className="info">
                        <div className="infoTitle">
                            <div style={{ fontSize: "8px", width: "auto", whiteSpace: "nowrap" }}>
                                LABEL BRAND INFO
                            </div>
                            <div className="dividerHorizontal" />
                        </div>
                        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                            <div className="infoLabel">
                                <div>Stores:</div>
                                <div className="value">{Data?.labelBrandInfo?.store || "--"}</div>
                            </div>
                            <div className="infoLabel">
                                <div>Connections:</div>
                                <div className="value">{Data?.labelBrandInfo?.connections || "--"}</div>
                            </div>
                            <div className="infoLabel">
                                <div>BOtag rating:</div>
                                <div className="value">{Data?.labelBrandInfo?.botagRating || "--"}</div>
                            </div>
                            <div className="infoLabel">
                                <div>Stock sharing:</div>
                                <div className="value">{Data?.labelBrandInfo?.stockSharing || "--"}</div>
                            </div>
                        </div>
                    </div>
                    <div className="dividerVertical" />
                </div> */}
                <div style={{ display: "flex", gap: "8px", width: "100%" }}>
                    <div className="info">
                        <div className="infoTitle">
                            <div style={{ fontSize: "8px", width: "auto", whiteSpace: "nowrap" }}>CONTACT INFO</div>
                            <div className="dividerHorizontal" />
                        </div>
                        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                            <div className="infoLabel">
                                <div>HQ:</div>
                                <div className="value" style={{ maxWidth: "200px" }}>
                                    {formatAddress(whoIsThisData?.labelBrnadInfo?.mainOffice) || "--"}
                                </div>
                            </div>
                            <div className="infoLabel">
                                <div>Contact person:</div>
                                <div className="value">{whoIsThisData?.invitedByUserInfo?.firstName || "--"}</div>
                            </div>
                            <div className="infoLabel">
                                <div>Email:</div>
                                <div className="value" style={{ maxWidth: "200px" }}>
                                    {whoIsThisData?.invitedByUserInfo?.email || "--"}
                                </div>
                            </div>
                            <div className="infoLabel">
                                <div>Phone number:</div>
                                <div className="value">{whoIsThisData?.invitedByUserInfo?.phoneNumber || "--"}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="infoTitle" style={{ margin: "16px 0" }}>
                <div className="dividerHorizontal" />
                <div style={{ fontSize: "8px", width: "auto", whiteSpace: "nowrap" }}>STORES</div>
                <div className="dividerHorizontal" />
            </div>
            {/* <div className="storesList">
                {Object.keys(Data.stores).map(key => {
                    const store = Data.stores[key];
                    return (
                        <div key={key} className="storeCard">
                            <div className="storeImage">
                                <img alt={store.name} src={store.image || noLogoImage} />
                                <div className="infoStore">
                                    <div>{store.name}</div>
                                    <div>{store.address}</div>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div> */}
            <div className="bottomContent">
                <button className={"CardBox-button-a"} style={{ width: "100%" }} onClick={() => setIsOpen(false)}>
                    CLOSE
                </button>
                {/* <button className={"CardBox-button-a"} style={{ width: "100%" }}>
                    SEE STORES ON HEYBO
                </button> */}
                <button
                    className={`CardBox-button-a ${!canAcceptInvite ? "CardBoxDisabled" : ""}`}
                    style={{ width: "100%" }}
                    onClick={canAcceptInvite ? () => onDeclineInvitation(item) : undefined}>
                    DECLINE
                </button>
                <button
                    className={`CardBox-button-a ${!canAcceptInvite ? "CardBoxDisabled" : ""}`}
                    style={{ width: "100%" }}
                    onClick={
                        canAcceptInvite
                            ? () => onAcceptInvitation(item?._id, item?.labelBrand?.name, item?.retailBrand?.name)
                            : undefined
                    }>
                    ACCEPT
                </button>
            </div>
        </StyledLayout>
    );
}
